/*
 * Navbar background on scroll (original page-scroll action a-64).
 *
 * The navbar is transparent at the top of the page (`background-color: #fff0`)
 * and scrubs to solid white between 1% and 3% of the total page scroll, exactly
 * like the original continuous interaction.
 */
import type { gsap as GSAP } from 'gsap'

import { gsap, ScrollTrigger } from './core'

export const initNavbarScroll = (ctx: GSAP.Context, scope: HTMLElement): void => {
    ctx.add(() => {
        const navbar = scope.querySelector<HTMLElement>('.navbar')
        if (!navbar) return

        gsap.fromTo(
            navbar,
            { backgroundColor: 'rgba(255, 255, 255, 0)' },
            {
                backgroundColor: 'rgba(255, 255, 255, 1)',
                ease: 'none',
                scrollTrigger: {
                    start: () => ScrollTrigger.maxScroll(window) * 0.01,
                    end: () => ScrollTrigger.maxScroll(window) * 0.03,
                    scrub: true,
                    invalidateOnRefresh: true
                }
            }
        )
    })
}
